import React, {useState, useEffect} from 'react';
import {Box, IconButton} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CancelIcon from '@mui/icons-material/SearchOff';
import CustomSelect from '@/shared/CustomSelect';
import CustomMultipleSelect from '@/shared/CustomMultipleSelect';
import {useE4ImpactProjectsContext} from './context';
import {IFieldProps} from '@/resources/Field';

import './filter-styles.scss';

interface IFiltersProps {
    search: any,
    setSearch: (search: any) => void
    clearSearch: () => void
    runSearch: () => void
}

export function Filters({search, setSearch, clearSearch, runSearch}: IFiltersProps) {
    const {filterUoas, fields, breakdowns, questionsChoices} = useE4ImpactProjectsContext();

    const [countries, setCountries] = useState([]);
    const [projects, setProjects] = useState([]);
    const [genderField, setGenderField] = useState<IFieldProps | undefined>(undefined);
    const [selectedCountries, setSelectedCountries] = useState<string[]>([]);

    const handleSearchChange = (key: string, value: any) => {
        const data: any = {...search};
        data[key] = value;

        setSearch(data);
    }

    useEffect(() => {
        const projectBreakdowns = breakdowns.find((breakdown: any) => breakdown.slug === 'projects');

        if (projectBreakdowns) {
            setCountries(projectBreakdowns.levels.filter((level: any) => level.parent_id === null))
            setProjects(projectBreakdowns.levels.filter((level: any) => !!level.parent_id))
        }
    }, [breakdowns])

    useEffect(() => {
        const gender = fields.find((field: IFieldProps) => field.key === 'genere');

        if (gender) {
            setGenderField(gender);
        }
    }, [fields])

    useEffect(() => {
        if (search.selectedProjects.length > 0) {
            const projectBreakdowns = breakdowns.find((breakdown: any) => breakdown.slug === 'projects');

            setSelectedCountries(
                projectBreakdowns.levels
                    .filter((level: any) => search.selectedProjects.includes(level.id))
                    .map((level: any) => level.parent_id)
            )
        }
    }, [search])

    return (
        <div className='data-filter'>
            <CustomMultipleSelect
                items={filterUoas.map((item: any) => ({name: item.title, id: item.id}))}
                value={search.selectedUoas}
                onChange={(value: any) => handleSearchChange('selectedUoas', value)}
                label='UoA'
                className='uoa-select'
            />
            <CustomMultipleSelect
                items={countries}
                value={selectedCountries}
                onChange={(value: any) => setSelectedCountries(value)}
                label='Country'
                className='uoa-select'
            />
            {
                selectedCountries.length > 0 && <CustomMultipleSelect
                    items={projects.filter((level: any) => selectedCountries.includes(level.parent_id))}
                    value={search.selectedProjects}
                    onChange={(value: any) => handleSearchChange('selectedProjects', value)}
                    label='Name of Project'
                    className='uoa-select'
                />
            }
            {
                selectedCountries.length === 0 && <CustomSelect
                    disabled={true}
                    items={[]}
                    value={null}
                    onChange={(_) => {}}
                    label='Name of Project'
                    className='uoa-select'
                    defaultVariant='All'
                />
            }
            {
                genderField && <CustomSelect
                    items={genderField.options}
                    value={search.selectedGender}
                    onChange={(value: any) => handleSearchChange('selectedGender', value)}
                    label='Gender'
                    className='uoa-select'
                    defaultVariant='All'
                />
            }
            <CustomMultipleSelect
                items={questionsChoices.map((item: any) => ({name: item.text, id: item.value}))}
                value={search.selectedSectors}
                onChange={(value: any) => handleSearchChange('selectedSectors', value)}
                label='Sector'
                className='uoa-select'
            />

            <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'end'}}>
                <IconButton onClick={runSearch}>
                    <SearchIcon/>
                </IconButton>
                <IconButton onClick={clearSearch}>
                    <CancelIcon/>
                </IconButton>
            </Box>
        </div>
    )
}